import { SerializableObject } from '../../common-react/core';

// DTO Object for representing generic Country
export class Country extends SerializableObject {
  // Country code
  public countryCode: string;

  // Name of the country
  public name: string;

  // Telephone country calling code
  public telephoneCode?: string;

  // Indicates if the country is closed
  public isClosed: boolean;

  // If it is closed this explains why
  public isClosedExplanation?: string;
}
